
const Index = r => require.ensure([], () => r(require('./Index')), 'H5APP')
const H5APP = r => require.ensure([], () => r(require('./H5-APP')), 'H5APP')

export default {
  path: '/h5app',
  component: Index,
  children: [
    {
      path: 'h5-app',
      name: 'hPCCode',
      component: H5APP
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/H5APP/router.js